import React, { useState, useEffect, useRef } from "react";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { customGetAPI } from "services/utils/CustomAPI";
import { leaveSummaryListView } from "../TeamZoneHeaders";
import { CalendarMonth, Search } from "@mui/icons-material";
import { CancelLeave } from "./CancelLeave";
import * as Mui from "@mui/material";
import {
  themes,
  defaultAllSelection,
  tableRowSx,
  leaveFilterKey,
  scrollTop,
  optionalAvathar,
} from "services/constants";
import { Loader } from "components/Loader";
import { PastLeaveDetails } from "./PastLeaveDetails";
import {
  Visibility,
  AccountBalance,
  KeyboardArrowDown,
} from "@mui/icons-material";
import "./ButtonGroup.css";
import { styled } from "@mui/system";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import { parse, format } from "date-fns";
import sessionHandling from "services/utils/notificationUtils";
import { tooltipStyleProps } from "services/constants/Styles";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const HoverVisibilityButton = styled(Mui.IconButton)`
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
export const LeaveSummary = () => {
  const dispatch = useDispatch();
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const [departmentData, setDepartmentData] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [reUpdatePastLeaveDetails, setReUpdatePastLeaveDetails] =
    useState(false);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [leaveDate, setLeaveDate] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredLabel, setFilteredLabel] = useState("");
  const [filteredValue, setFilteredValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedSubMenuAnchorEl, setExpandedSubMenuAnchorEl] = useState(null);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [cancelLeaveData, setCancelLeaveData] = useState({});
  const [updateData, setUpdateData] = useState(true);
  const containerRef = useRef(null);
  const [leaveYearId, setLeaveYearId] = useState("");

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = departmentData.filter((data) =>
    data?.label?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    dispatch(setDepartmentName("All"));
    dispatch(setDepartmentId(99999));
  }, [dispatch]);

  const formatDate = (dateString) => {
    const date = parse(dateString, "dd-MM-yyyy", new Date());
    const formattedDate = format(date, "yyyy-MM-dd");
    return formattedDate;
  };

  useEffect(() => {
    if (topbarCompanyId) {
      setUpdateData(true);
    }
  }, [topbarCompanyId]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const departmentDataWithLabel = res.map((obj) => ({
            ...obj,
            label: obj.department_name,
          }));
          const allDepartment = {
            id: defaultAllSelection,
            label: "All",
            departmentname: "All",
          };
          setDepartmentData([allDepartment, ...departmentDataWithLabel]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [domain, token, userDetails.id]);

  useEffect(() => {
    const fetchLeaveDate = async () => {
      try {
        const response = await fetch(`${domain}leaves-years/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const leaveDate = res.map((value) => ({
            label: value.name,
            start_date: value.start_date,
            end_date: value.end_date,
            filteredValue: `${value.start_date} - ${value.end_date}`,
          }));
          const sDate = formatDate(res[0]?.start_date);
          const eDate = formatDate(res[0]?.end_date);
          setLeaveYearId(res[0]?.id);
          setLeaveDate(leaveDate);
          setFilteredLabel(res[0]?.name);
          setFilteredValue(`${res[0]?.start_date} - ${res[0]?.end_date}`);
          setStartDate(sDate);
          setEndDate(eDate);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchLeaveDate();
  }, [domain, token]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const res = await customGetAPI(
        `${domain}leave-summary-admin/?department_id=${departmentId}&user_id=${userDetails?.id}&start_date=${startDate}&end_date=${endDate}&company_id=${topbarCompanyId}`
      );
      if (res.ok) {
        setData(res?.responseDetails);
        setMasterDataForSearch(res?.responseDetails);
      }
      setLoading(false);
    };
    if (startDate && endDate && updateData) {
      fetchData();
      setUpdateData(false);
    }
  }, [
    departmentId,
    domain,
    endDate,
    startDate,
    token,
    topbarCompanyId,
    updateData,
    userDetails?.id,
    userDetails.type,
  ]);

  const handleVisibilityToggle = (user) => {
    setSelectedUser(user);
    setShowDetails(true);
  };

  const handleClose = () => {
    setShowDetails(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const filteredResults = masterDataForSearch?.filter((item) =>
      leaveFilterKey?.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setData(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterDataForSearch, page]);

  const getTeammateDetails = async (p_startDate, p_endDate, Id) => {
    setLoading(true);
    const res = await customGetAPI(
      `${domain}leave-summary-admin/?department_id=${Id}&user_id=${userDetails?.id}&start_date=${p_startDate}&end_date=${p_endDate}&company_id=${topbarCompanyId}`
    );
    if (res.ok) {
      setData(res?.responseDetails);
      setMasterDataForSearch(res?.responseDetails);
      setShowDetails(false);
      setReUpdatePastLeaveDetails(false);
      setLoading(false);
    } else {
      setData([]);
      setMasterDataForSearch([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return (
    <div className="mt-4">
      {showDetails && !cancelConfirmation ? (
        <Mui.Grid container>
          <Mui.Grid xs={12}>
            <PastLeaveDetails
              selectedUser={selectedUser}
              setReUpdatePastLeaveDetails={setReUpdatePastLeaveDetails}
              reUpdatePastLeaveDetails={reUpdatePastLeaveDetails}
              filteredValue={filteredValue}
              filteredLabel={filteredLabel}
              setFilteredValue={setFilteredValue}
              setFilteredLabel={setFilteredLabel}
              startDate={startDate}
              endDate={endDate}
              leaveDate={leaveDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setSelectedUser={setSelectedUser}
              handleClose={handleClose}
              setCancelConfirmation={setCancelConfirmation}
              setCancelLeaveData={setCancelLeaveData}
            />
          </Mui.Grid>
        </Mui.Grid>
      ) : cancelConfirmation ? (
        <CancelLeave
          setCancelConfirmation={setCancelConfirmation}
          cancelLeaveData={cancelLeaveData}
          setCancelLeaveData={setCancelLeaveData}
          leaveYearId={leaveYearId}
        />
      ) : (
        <>
          {showDetails === false ? (
            <>
              <Mui.Grid container>
                <Mui.Grid item sx={{ paddingLeft: 2 }}>
                  <Mui.Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      width: 270,
                      height: 120,
                      backgroundColor: "#FFF8E5",
                    }}
                  >
                    <Mui.Grid container sx={{ paddingLeft: 2 }}>
                      <Mui.Grid
                        xs={2}
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          width: 40,
                          height: 40,
                          backgroundColor: "#FFD83A",
                          borderRadius: "50%",
                        }}
                      >
                        <AccountBalance
                          style={{ color: "white", alignItems: "center" }}
                          fontSize="medium"
                        />
                      </Mui.Grid>
                      &nbsp; &nbsp;
                      <Mui.Grid xs={7}>
                        <Mui.Typography
                          style={{
                            fontSize: "18px",
                            fontWeight: "800",
                            textTransform: "capitalize",
                          }}
                        >
                          {departmentName.length > 10 ? (
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title={departmentName}
                            >
                              <span>{`${departmentName.substring(
                                0,
                                10
                              )}..`}</span>
                            </Mui.Tooltip>
                          ) : (
                            departmentName
                          )}
                        </Mui.Typography>
                      </Mui.Grid>
                      <Mui.Grid xs={2} sx={{ paddingRight: 2 }}>
                        <Mui.IconButton
                          onClick={(e) =>
                            setExpandedSubMenuAnchorEl(e.currentTarget)
                          }
                        >
                          <KeyboardArrowDown />
                        </Mui.IconButton>
                      </Mui.Grid>
                    </Mui.Grid>
                  </Mui.Box>
                  <Mui.Popover
                    anchorEl={expandedSubMenuAnchorEl}
                    open={Boolean(expandedSubMenuAnchorEl)}
                    onClose={() => {
                      setExpandedSubMenuAnchorEl(null);
                      setSearchQuery("");
                    }}
                    anchorReference="anchorPosition"
                    anchorPosition={{ top: 355, left: 536 }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "right",
                    }}
                    PaperProps={{
                      style: {
                        maxHeight: "200px",
                        width: "270px",
                        overflowY: "auto",
                      },
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "200px",
                      }}
                    >
                      <Mui.TextField
                        variant="outlined"
                        size="small"
                        margin="dense"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <Mui.InputAdornment position="end">
                              <Search />
                            </Mui.InputAdornment>
                          ),
                        }}
                      />
                      <div
                        style={{ flex: 1, overflowY: "auto", height: "50px" }}
                      >
                        {filteredData.length > 0 ? (
                          filteredData.map((data) => (
                            <Mui.MenuItem
                              key={data.department_id}
                              onClick={() => {
                                if (data && data.label) {
                                  dispatch(setDepartmentName(data.label));
                                  dispatch(setDepartmentId(data.id));
                                }
                                setSearchQuery("");
                                setExpandedSubMenuAnchorEl(null);
                                setExpandedSubMenuAnchorEl(null);
                                setUpdateData(true);
                              }}
                            >
                              {data.label}
                            </Mui.MenuItem>
                          ))
                        ) : (
                          <Mui.MenuItem disabled>
                            No data available
                          </Mui.MenuItem>
                        )}
                      </div>
                    </div>
                  </Mui.Popover>
                </Mui.Grid>
                <Mui.Grid
                  xs={9.8}
                  item
                  sx={{ paddingBottom: 5 }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "flex-end",
                    justifyContent: "flex-end",
                  }}
                >
                  <Mui.Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    size="small"
                    value={
                      leaveDate?.find(
                        (option) => option?.filteredValue === filteredValue
                      ) || ""
                    }
                    options={leaveDate}
                    style={{
                      width: 305,
                    }}
                    getOptionLabel={(option) =>
                      option?.filteredValue ?? filteredValue ?? ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option?.filteredValue === value?.filteredValue
                    }
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option.filteredValue
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    renderOption={(props, option) => {
                      return <li {...props}>{option.filteredValue}</li>;
                    }}
                    ListboxProps={{
                      style: {
                        maxHeight: "150px",
                      },
                    }}
                    onChange={(event, value) => {
                      if (value && value.filteredValue) {
                        setFilteredLabel(value.label);
                        setFilteredValue(value.filteredValue);
                        setStartDate(formatDate(value.start_date));
                        setEndDate(formatDate(value.end_date));
                        getTeammateDetails(
                          formatDate(value.start_date),
                          formatDate(value.end_date),
                          departmentId
                        );
                      }
                    }}
                    renderInput={(params) => (
                      <Mui.TextField
                        {...params}
                        sx={{ background: themes.whiteColor }}
                        placeholder="Select leave period"
                        label={filteredLabel ? filteredLabel : "Leave Period"}
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <CalendarMonth
                                style={{ margin: "0 8px", color: "#a6a6a6" }}
                              />
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Mui.Grid>
              </Mui.Grid>
            </>
          ) : null}
          {!loading ? (
            <Mui.Grid container>
              <Mui.TableContainer
                ref={containerRef}
                sx={{
                  marginTop: 5,
                  marginLeft: "auto",
                  marginRight: "auto",
                  maxWidth: "100%",
                  maxHeight: 660,
                  ml: 2,
                  mr: 2,
                }}
                className="w-96 border  rounded "
              >
                <Mui.Table className="border">
                  <Mui.TableHead
                    sx={{
                      backgroundColor: themes.primary,
                      position: "sticky",
                      top: -1,
                      zIndex: 10,
                      "& .MuiTableCell-root": {
                        height: "15px",
                        padding: "3px 12px",
                      },
                    }}
                  >
                    <Mui.TableRow sx={tableRowSx}>
                      {leaveSummaryListView.map((header) => (
                        <Mui.TableCell
                          sx={{
                            color: themes.headLine,
                            fontWeight: "bold",
                          }}
                        >
                          {header.name}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>
                  <Mui.TableBody>
                    {data?.length === 0 ? (
                      <InfoMessage dataLength={masterDataForSearch} />
                    ) : (
                      data
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((user) => (
                          <Mui.TableRow sx={tableRowSx}>
                            {leaveSummaryListView.map((header) =>
                              header?.name === "Name" ? (
                                <Mui.TableCell sx={{ color: themes.headLine }}>
                                  <Mui.Stack direction="Row">
                                    <Mui.Avatar
                                      sx={{ width: 23, height: 23 }}
                                      alt={user?.user_name
                                        ?.charAt(0)
                                        .toUpperCase()}
                                      src={user?.image_url ?? optionalAvathar}
                                    />
                                    <Mui.Typography
                                      sx={{
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        paddingLeft: 1,
                                      }}
                                    >
                                      {user?.user_name}
                                    </Mui.Typography>
                                  </Mui.Stack>
                                </Mui.TableCell>
                              ) : header?.name !== "Action" ? (
                                <Mui.TableCell sx={{ color: themes.headLine }}>
                                  <Mui.Tooltip
                                    arrow
                                    slotProps={tooltipStyleProps}
                                    title={user[header.key]}
                                  >
                                    {user[header.key] || user[header.key] === 0
                                      ? user[header.key]
                                      : "N/A"}
                                  </Mui.Tooltip>
                                </Mui.TableCell>
                              ) : (
                                <Mui.TableCell>
                                  <Mui.Tooltip
                                    arrow
                                    slotProps={tooltipStyleProps}
                                    title="View"
                                    placement="left"
                                  >
                                    <HoverVisibilityButton
                                      size="small"
                                      onClick={() => {
                                        handleVisibilityToggle(user);
                                        setReUpdatePastLeaveDetails(true);
                                        dispatch(setGlobalSearchValue(""));
                                      }}
                                    >
                                      <Visibility />
                                    </HoverVisibilityButton>
                                  </Mui.Tooltip>
                                </Mui.TableCell>
                              )
                            )}
                          </Mui.TableRow>
                        ))
                    )}
                  </Mui.TableBody>
                </Mui.Table>
              </Mui.TableContainer>
            </Mui.Grid>
          ) : (
            loading && (
              <div>
                <Loader info="Loading..." />
              </div>
            )
          )}
        </>
      )}
      {data?.length > 25 && showDetails === false && (
        <Mui.TablePagination
          sx={{ marginRight: 5 }}
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={data?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};
